export default __webpack_public_path__ + "static/media/news-3.dbe8be17.png";